import { formatDateDmy, formatTime } from "@/utils/helper";
import { useNow } from "./use-now";

/**
 * Live wall-clock for the banner. Ticks on the minute — on an attendance-driven
 * dashboard the current time is load-bearing context for the clock-in bar below.
 *
 * Left-aligned on mobile, where it anchors the left edge of a rail spread across
 * the full width; right-aligned once that rail becomes a compact group.
 */
export const LocalTime = () => {
  const now = useNow("minute");

  return (
    <div className="flex flex-col items-start leading-tight sm:items-end">
      <time
        dateTime={now.toISOString()}
        className="text-xl font-semibold tabular-nums text-primary-strong sm:text-2xl"
      >
        {formatTime(now)}
      </time>
      <span className="text-[11px] text-primary-strong/60">{formatDateDmy(now)}</span>
    </div>
  );
};
